import { formatPatientName } from '@/utils/formatPatientName'
import { useGeneralStore } from '../../../../store/generalStore'
import { useDecodedToken } from '../../hooks/useDecodedToken'
import { useWebChatMutation } from '../../hooks/useWebChatMutation'
import EmbededChatWindow from './EmbededChatWindow'

const WebChat = () => {
  const { chatToken, showChat, bubbleActive, setShowChat } = useGeneralStore()

  const { startChat } = useWebChatMutation()
  const decodedToken = useDecodedToken()

  const handleOpenChat = () => {
    startChat()
    setShowChat(true)
  }

  const handleCloseChat = () => setShowChat(false)

  return (
    <div className='fixed right-6 bottom-6 z-9999 flex flex-col items-end justify-end gap-4 rounded-xl'>
      {showChat && (
        <EmbededChatWindow
          onClose={handleCloseChat}
          chatToken={chatToken ?? ''}
          patientId={decodedToken?.patient_id ?? ''}
          patientName={
            decodedToken
              ? formatPatientName(decodedToken?.first_name, decodedToken?.middle_name, decodedToken?.last_name)
              : ''
          }
          patientState={decodedToken?.state ?? ''}
          householdId={decodedToken?.household_group_id ?? ''}
          patientPhoneNumber={decodedToken?.phone_number ?? ''}
        />
      )}
      {bubbleActive && (
        <div>
          <button
            type='button'
            className='flex h-18 w-18 cursor-pointer items-center justify-center rounded-full border-none bg-[#0F687C] p-4'
            onClick={showChat ? handleCloseChat : handleOpenChat}
            aria-label={showChat ? 'Close chat' : 'Open chat'}
          >
            <div className='flex h-6 w-6 items-center justify-center'>
              <img
                src={showChat ? '/images/downArrow.svg' : '/images/chat.svg'}
                alt='Web Chat'
                className={`object-contain ${showChat ? 'h-4 w-4' : 'h-full w-full'}`}
              />
            </div>
          </button>
        </div>
      )}
    </div>
  )
}

export default WebChat
